module.exports = __webpack_public_path__ + "img/jwt.4331785a.png";